import { categoryLists } from 'api/account'
// let obj = {
//     2: '1-1',
//     17: '1-3',
//     18: '2-1',
//     19: '2-4',
//     20: '2-5',
//     21: '2-6',
//     22: '2-7',
//     38: '2-3',
//     39: '2-2',
//     24: '3-1',
//     25: '3-5',
//     26: '3-6',
//     27: '3-7',
//     1: '5-5',
//     7: '5-7',
//     8: '5-4',
//     10: '5-3',
//     11: '5-2',
//     12: '5-1',
//     35: '5-6',
//     36: '5-8',
//     15: '',
//     28: '',
//     29: '',
//     30: '',
//     31: '',
//     32: '',
//     33: '',
//     34: ''
// }

export default {
    data () {
        return {
            lists: [] // 接口返回数据
        }
    },
    created () {
        categoryLists().then(res => {
            if (res.data.success) {
                this.lists = res.data.list
            }
        })
    },
    computed: {
        initData () {
            let temp = []
            this.lists.forEach(item => {
                // 1是否展示
                if (item.showFlag !== 1) {
                    return
                }
                // 添加图片
                item.src = item.benefitIcon || require(`@/assets/images/rightsInterests/category-7.png`);
                if (item.categoryId === 15) { // 免费创意云
                    let res = this.formatUserBenefitList(item)
                    temp = res.concat(temp)
                } else {
                    temp.push(item)
                }
            })

            // 去重
            let arr = []
            let result = []
            temp.forEach(item => {
                if (!arr.includes(item.showName)) {
                    arr.push(item.showName)
                    result.push(item)
                }
            })
            return result
        }
    },
    methods: {
        formatUserBenefitList (item) {
            const arr = [...item.userBenefitList]
            let result = arr.map(val => {
                val.href = 'click'
                val.showName = val.benefitIdName
                val.useType = item.useType
                val = Object.assign({}, item, val)
                return val
            })
            return result.slice(0, 1)
        }
    }
}
